/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_Command_Center_Has_Been_UInputs */

const en_your_command_center_has_been_u = /** @type {(inputs: Your_Command_Center_Has_Been_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your command center has been updated.`)
};

const es_your_command_center_has_been_u = /** @type {(inputs: Your_Command_Center_Has_Been_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu centro de mando ha sido actualizado.`)
};

const fr_your_command_center_has_been_u = /** @type {(inputs: Your_Command_Center_Has_Been_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre centre de commandement a été mis à jour.`)
};

const de_your_command_center_has_been_u = /** @type {(inputs: Your_Command_Center_Has_Been_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Kommandozentrale wurde aktualisiert.`)
};

const ja_your_command_center_has_been_u = /** @type {(inputs: Your_Command_Center_Has_Been_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コマンドセンターが更新されました。`)
};

const zh_your_command_center_has_been_u = /** @type {(inputs: Your_Command_Center_Has_Been_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的指挥中心已更新。`)
};

const ar_your_command_center_has_been_u = /** @type {(inputs: Your_Command_Center_Has_Been_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم تحديث مركز القيادة الخاص بك.`)
};

const id_your_command_center_has_been_u = /** @type {(inputs: Your_Command_Center_Has_Been_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pusat komando Anda telah diperbarui.`)
};

const it_your_command_center_has_been_u = /** @type {(inputs: Your_Command_Center_Has_Been_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo centro di comando è stato aggiornato.`)
};

const ru_your_command_center_has_been_u = /** @type {(inputs: Your_Command_Center_Has_Been_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш командный центр был обновлен.`)
};

const pt_your_command_center_has_been_u = /** @type {(inputs: Your_Command_Center_Has_Been_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O seu centro de comando foi atualizado.`)
};

const ko_your_command_center_has_been_u = /** @type {(inputs: Your_Command_Center_Has_Been_UInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`커맨드 센터가 업데이트되었습니다.`)
};

/**
* | output |
* | --- |
* | "Your command center has been updated." |
*
* @param {Your_Command_Center_Has_Been_UInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const your_command_center_has_been_u = /** @type {((inputs?: Your_Command_Center_Has_Been_UInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_Command_Center_Has_Been_UInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_your_command_center_has_been_u(inputs)
	if (locale === "es") return es_your_command_center_has_been_u(inputs)
	if (locale === "fr") return fr_your_command_center_has_been_u(inputs)
	if (locale === "de") return de_your_command_center_has_been_u(inputs)
	if (locale === "ja") return ja_your_command_center_has_been_u(inputs)
	if (locale === "zh") return zh_your_command_center_has_been_u(inputs)
	if (locale === "ar") return ar_your_command_center_has_been_u(inputs)
	if (locale === "id") return id_your_command_center_has_been_u(inputs)
	if (locale === "it") return it_your_command_center_has_been_u(inputs)
	if (locale === "ru") return ru_your_command_center_has_been_u(inputs)
	if (locale === "pt") return pt_your_command_center_has_been_u(inputs)
	return ko_your_command_center_has_been_u(inputs)
});